import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, PrimaryButton, getPaymentProcessorTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import HelpCenterLink from 'modules/profile/payment-gateways/components/help-center-link';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { cashOnDeliveryConnect } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/api';
import { CashOnDeliveryCreateIntegrationInterface, CashOnDeliveryErrorsIntegrationInterface } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/types';
import { getCashOnDeliveryHelpPageLink } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/utils';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import FormTextarea from 'shared/components/form-textarea';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
const defaultValues: CashOnDeliveryCreateIntegrationInterface = {
  instructions: ''
};
const defaultErrors: CashOnDeliveryErrorsIntegrationInterface = {
  instructions: ''
};
const CashOnDeliveryCreateModal = () => {
  const $ = _c(33);
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  const [opened, setOpened] = useState(false);
  const [errors, setErrors] = useState(defaultErrors);
  const {
    mutatePaymentIntegrations
  } = useConnectedPaymentIntegrations();
  let t0;
  if ($[0] !== mutatePaymentIntegrations) {
    t0 = async data => {
      await fetchWithErrors(async () => {
        await cashOnDeliveryConnect(data);
        await mutatePaymentIntegrations();
      }, setErrors);
    };
    $[0] = mutatePaymentIntegrations;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCreate = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e => {
      e.preventDefault();
      setOpened(true);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.settings.payment_gateways.connect");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <PrimaryButton onClick={t1} className="font-bold">{t2}</PrimaryButton>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.settings.payment_gateways.connect_cash_on_delivery_payment");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== tUi) {
    t5 = getPaymentProcessorTitle(PaymentProcessorEnum.CashOnDelivery, tUi);
    $[9] = tUi;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setOpened(false);
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== errors || $[13] !== t) {
    t7 = [{
      field: "instructions",
      onRender: (value, onChange) => <FormTextarea key="cash-on-delivery-create-instructions" onChange={e_0 => onChange(e_0.target.value)} label={t("dashboard.settings.payment-gateways.instructions_title")} value={value || ""} className="min-h-[126px]" description={errors.instructions} />
    }];
    $[12] = errors;
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = user?.dashboardLocale;
  let t9;
  if ($[15] !== t8) {
    t9 = getCashOnDeliveryHelpPageLink(t8);
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== tUi) {
    t10 = getPaymentProcessorTitle(PaymentProcessorEnum.CashOnDelivery, tUi);
    $[17] = tUi;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <HelpCenterLink link={t9} integration={t10} />;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = ["instructions"];
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== onCreate || $[24] !== opened || $[25] !== t11 || $[26] !== t4 || $[27] !== t5 || $[28] !== t7) {
    t13 = <CreateModal fullCaption={t4} caption={t5} needToast={false} opened={opened} onClose={t6} defaultValues={defaultValues} creatable={t7} additionalInfo={t11} onCreate={onCreate} requiredFields={t12} />;
    $[23] = onCreate;
    $[24] = opened;
    $[25] = t11;
    $[26] = t4;
    $[27] = t5;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t3) {
    t14 = <>{t3}{t13}</>;
    $[30] = t13;
    $[31] = t3;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
export default CashOnDeliveryCreateModal;